import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { AgCharts } from "ag-charts-react";

import { salaryAbsencesQuery } from "../../api";
import { customChartThemes } from "../../common/grid";
import { LoadingContainer } from "../../common/loaders/loadingcontainer";
import { localized } from "../../common/utils";


export function AbsenceDays() {
  const { t } = useTranslation();

  const { data } = useQuery(salaryAbsencesQuery);
  const [formattedData, setFormattedData] = useState();

  const { chartTheme } = customChartThemes;

  function calculateMonthlyAbsenceDays(data) {
    const monthlyDays = {};

    // Iterate through the JSON array
    data.forEach(item => {
      const days = item.DAYS;
      const startDate = new Date(item.STARTDATE.replace(/(\d{2}).(\d{2}).(\d{4})/, "$3-$2-$1"));
      const endDate = new Date(item.ENDDATE.replace(/(\d{2}).(\d{2}).(\d{4})/, "$3-$2-$1"));

      while (startDate <= endDate) {
        const monthYear = `${startDate.getMonth() + 1}-${startDate.getFullYear()}`;

        monthlyDays[monthYear] = (monthlyDays[monthYear] || 0) + days;

        startDate.setMonth(startDate.getMonth() + 1);
      }
    });

    return monthlyDays;
  }

  useEffect(() => {
    if (data) {
      const salaryabsences = data.salaryabsences_response.salaryabsences ?? [];
      const monthlyAbsenceDays = calculateMonthlyAbsenceDays(salaryabsences);
      setFormattedData(Object.keys(monthlyAbsenceDays).map(monthYear => {
        const [month, year] = monthYear.split("-");
        return {
          month: `${month}/${year}`,
          value: monthlyAbsenceDays[monthYear],
        };
      }));
    }
  }, [data]);

  /** @type {import("ag-grid-enterprise").AgChartOptions} */
  const options = {
    data: formattedData,
    series: [
      {
        type: "line",
        xKey: "month",
        yKey: "value",
        xName: t("Month", "Kuukausi"),
      },
    ],
    legend: {
      enabled: false,
    },
    theme: { ...chartTheme, palette: { ...chartTheme.palette, fills: ["#B7A0E0"] } },
    overlays: {
      noData: { text: `${t("No", "Ei")} ${t("data", "tietoja")}` },
    },
    locale: localized.agChartsLocale,
  };


  return formattedData ? (
    <>
      <h4 style={{ color: "var(--heeros-blue)" }}>{t("MonthlyAbsenceDays", "Kuukausittaiset poissaolopäivät")}</h4>

      <div style={{ width: "100%", maxWidth: "100%", minWidth: 0, overflowX: "hidden" }}>
        <AgCharts options={options} style={{ width: '100%' }} />
      </div>

    </>
  ) : (
    <LoadingContainer />
  );
}
